export default __webpack_public_path__ + "static/media/vc4.3e5a0e1d.jpg";